import { useHistory } from 'react-router-dom';

import {
  IdCardWrapper,
  TitleAndCommandsWrapper,
  TitlesWrapper,
  CommandsWrapper,
  SaveChangesExitWrapper,
  TextualDetailsWrapper,
  SectionTitle,
  SubMenusWrapper,
  SaveChangesButton,
  DiscardChangesButton,
  IdCardTitle,
  ModuleTitle,
  ModuleTitleAndInputWrapper,
  ModuleTitleInput,
  DropDownWrapper,
  DeleteIdCardButton,
  DescriptionAndMainImageWrapper,
  OriginalCharacteristics,
  OriginalCharacteristicsWrapper,
} from './styles';

import DescriptionEdit from '../DescriptionEdit';
import CharacteristicsEdit from '../CharacteristicsEdit';
import PhysicalEdit from '../PhysicalEdit';
import SubMenuItem from '../SubMenuItem';
import Dropdown from '../Dropdown';
import ViewsAndLayoutsEdit from '../ViewsAndLayoutsEdit';
import WeightBreakdownEdit from '../WeightBreakdownEdit';
import LocationAndCraneCoverageEdit from '../LocationAndCraneCoverageEdit';
import MainTieInsEdit from '../MainTieInsEdit';
import EquipmentListEdit from '../EquipmentListEdit';
import DocumentationListEdit from '../DocumentationListEdit';
import OtherRelevantDocumentsEdit from '../OtherRelevantDocumentsEdit';
import ProjectNotesEdit from '../ProjectNotesEdit';
import useObjectElements from '../../hooks/useObjectElements';
import ModalView from '../ModalView';
import { useState } from 'react';
import NotFound from '../../screens/NotFound';
import useSaveChangesIdCard from '../../hooks/useSaveChangesIdCard';
import useDeleteIdCard from '../../hooks/useDeleteIdCard';
import Loader from '../Loader';
import { ImageContext } from '../../context/ImageContext';
import useDeleteImage from '../../hooks/useDeleteImage';
import FamiliesDropdown from '../FamiliesDropdown';
import SecondarySystemDropdown from '../SecondarySystemDropdown';
import ProjectsDropdown from '../ProjectsDropdown';
import ValidationInput from '../ValidationInput';
import { toast } from 'react-toastify';
import { Prompt } from 'react-router-dom';
import { DESIGN_MATURITY_OPTIONS, MODAL_ACTION } from '../../config/enums';
import MainImageEdit from '../MainImageEdit';
import { useIdCard } from '../../screens/HomeScreen/context/idCard';
import { useIdCatalogSearch } from '../SideMenuSearchLane/context';

const IdCardEdit = ({ onModalClose }) => {
  const { idCard: idCardData, idCardLoading, idCardImageArray } = useIdCard();
  let history = useHistory();
  const {
    object: idCardEditedData,
    setObjectValue: setEditedDataField,
    setMultipleObjectValues: setMultipleEditFields,
  } = useObjectElements({ initialValues: { ...idCardData } });
  if (idCardData && idCardData.documents && idCardEditedData && idCardEditedData.documents) {
    // documents added through import
    let importedDocuments = idCardData.documents.filter(d => !idCardEditedData.documents.includes(d));
    importedDocuments.forEach(newDoc => idCardEditedData.documents.push(newDoc));
  }
  if (idCardData && idCardData.equipmentList && idCardEditedData && idCardEditedData.equipmentList) {
    // equipment added through import
    let importedEquipment = idCardData.equipmentList.filter(d => !idCardEditedData.equipmentList.includes(d));
    importedEquipment.forEach(newEq => idCardEditedData.equipmentList.push(newEq));
  }
  const [idCardImages, setIdCardImages] = useState(idCardImageArray);
  const { saveChanges, isLoading: isLoadingSaveChanges } = useSaveChangesIdCard({ onModalClose });
  const { deleteIdCard, isLoading: isLoadingDelete } = useDeleteIdCard();
  const { deleteImage } = useDeleteImage();
  const { object: modalData, setObject: setModalData, setObjectValue: setModalProp } = useObjectElements({});
  const {
    removeCatalogItem,
    searchFilter,
    updateSearchFilterField,
  } = useIdCatalogSearch();

  const onCloseModal = () => {
    setModalProp(MODAL_ACTION.IS_OPEN, false);
  };

  const deleteAllUnusedUploadedImages = () => {
    // check for images that were uploaded but the changes weren't saved
    idCardImages.forEach((image) => {
      let containingImage = idCardImageArray.find((initialImage) => initialImage.imageId === image.imageId);
      if (containingImage === undefined) {
        deleteImage(image.imageId);
      }
    });
  };

  const onDiscardChangesNoClick = () => {
    setModalProp(MODAL_ACTION.IS_OPEN, false);
    deleteAllUnusedUploadedImages();
    onModalClose();
  };

  const onDiscardChangesYesClick = (idCardImages) => {
    setModalProp(MODAL_ACTION.IS_OPEN, false);
    onSaveIdCard(idCardEditedData, idCardImages);
  };

  const discardChangesHandler = (idCardImages) => {
    let exitModal = {
      modalIsOpen: true,
      modalTitle: 'Unsaved data',
      leftBtnTitle: 'NO, Discard Changes',
      rightBtnTitle: 'YES, Save Changes',
      modalDescription: 'Your are about to leave this page without saving. Would you like to save all changes?',
      onCloseModal,
      onBtnLeftClick: () => onDiscardChangesNoClick(),
      onBtnRightClick: () => onDiscardChangesYesClick(idCardImages),
    };
    setModalData(exitModal);
  };

  const onDeleteIdCard = (complete) => {
    setModalProp(MODAL_ACTION.IS_OPEN, false);
    deleteIdCard({ id: idCardData.id, complete, onSuccessCallback: () => {
      updateSearchFilterField('refreshToggle', !searchFilter.refreshToggle);
      removeCatalogItem(idCardEditedData.tagId);
    }});
    onModalClose();
  };

  const deleteIdCardHandler = () => {
    let deleteModal = {
      modalIsOpen: true,
      modalTitle: 'Are you sure?',
      leftBtnTitle: 'All versions',
      rightBtnTitle: 'Just this version',
      modalDescription:
        'When deleting, you can choose to just delete the current version, or delete the complete version history from the database.',
      onCloseModal,
      onBtnLeftClick: () => onDeleteIdCard(true), // complete = true - Delete all versions
      onBtnRightClick: () => onDeleteIdCard(false), // complete = false - Delete latest version
    };

    setModalData(deleteModal);
  };

  const validationFunc = (field, value) => {
    if (value?.length > 1) {
      return true;
    } else {
      toast.error(`Please fill in a value for ` + field, {
        position: toast.POSITION.TOP_LEFT,
      });
      return false;
    }
  };

  const onSaveIdCard = (idCardEditedData, idCardImages) => {
    const isCardValid =
      validationFunc('tsCode', idCardEditedData.tsCode) &&
      validationFunc('name', idCardEditedData.name) &&
      validationFunc('Project', idCardEditedData.projectId) &&
      validationFunc('description', idCardEditedData.description);
    if (!isCardValid) {
      return;
    }
    let chars = Object.keys(idCardEditedData.characteristics).map(function(key) {
      return idCardEditedData.characteristics[key];
    });
    idCardEditedData.characteristics = chars;
    saveChanges({ idCardEditedData, idCardImages });
  };

  const handleOnLeavePage = (location, action) => {
    if (action === 'POP') {
      return true;
    }

    if (modalData.modalIsOpen) {
      return true;
    }

    if (location?.state?.blockPopupModal) {
      return true;
    }

    if (history.location?.state?.blockPopupModal) {
      return true;
    }

    if (location?.state?.from?.pathname === `/catalog/idcard/${idCardData.tagId}/edit`) {
      return true;
    }

    setModalData({
      modalIsOpen: true,
      modalTitle: 'Unsaved data',
      leftBtnTitle: 'NO, Discard Changes',
      rightBtnTitle: 'YES, Save Changes',
      modalDescription: 'Your are about to leave this page without saving. Would you like to save all changes?',
      onCloseModal,
      onBtnLeftClick: () => onDiscardChangesNoClick(location.pathname),
      onBtnRightClick: () => onDiscardChangesYesClick(idCardImages),
    });
    return false;
  };

  const onSuccessImageUpload = (resData, imageFile, imageArrIndex) => {
    const updatedImages = [...idCardImages];
    updatedImages[imageArrIndex] = {
      imageId: resData,
      indexNr: imageArrIndex,
      legend: imageFile.name,
    };
    setIdCardImages(updatedImages);
  };

  const onSuccessImageRemove = (resData, imageFile, imageArrIndex) => {
    const updatedImages = [...idCardImages];
    updatedImages[imageArrIndex] = {
      imageId: null,
      indexNr: imageArrIndex,
      legend: '',
    };
    setIdCardImages(updatedImages);
  };

  const shouldSendDeleteImageReq = (imageId) => {
    let imageSavedInCard = idCardImageArray.find((image) => image.imageId === imageId);
    return !imageSavedInCard;
  };

  let isSomeActionLoading = isLoadingSaveChanges || isLoadingDelete;

  return (
    <IdCardWrapper>
      {!idCardLoading && !idCardData ? (
        <NotFound />
      ) : isSomeActionLoading ? (
        <Loader />
      ) : (
        <ImageContext.Provider
          value={{
            idCardImages,
            setIdCardImages,
            onSuccessImageUpload,
            onSuccessImageRemove,
            shouldSendDeleteImageReq,
          }}>
          <Prompt
            when={true}
            message={(location, action) => {
              return handleOnLeavePage(location, action);
            }}
          />
          <ModalView
            isOpen={modalData.modalIsOpen}
            title={modalData.modalTitle}
            description={modalData.modalDescription}
            onCloseBtn={modalData.onCloseModal}
            onBtnLeftClick={modalData.onBtnLeftClick}
            onBtnRightClick={modalData.onBtnRightClick}
            leftBtnTitle={modalData.leftBtnTitle}
            rightBtnTitle={modalData.rightBtnTitle}
          />
          <TitleAndCommandsWrapper>
            <TitlesWrapper>
              <ModuleTitleAndInputWrapper>
                <IdCardTitle>Project</IdCardTitle>
                <DropDownWrapper>
                  <ProjectsDropdown
                    projectId={idCardEditedData.projectId}
                    setDataFunc={setMultipleEditFields}
                  />
                </DropDownWrapper>
              </ModuleTitleAndInputWrapper>
              <ModuleTitleAndInputWrapper>
                <ModuleTitle>Module:</ModuleTitle>
                <ValidationInput
                  component={ModuleTitleInput}
                  containerStyle={{ width: '75%', height: '100%' }}
                  placeholder='Module Number'
                  value={idCardEditedData.tsCode ?? ''}
                  onChange={(e) => setEditedDataField('tsCode', e.target.value)}
                  name='moduleNumber'
                  validation={validationFunc}
                  errorMsg={'Module number must be longer than 1 char'}
                />
                <ValidationInput
                  component={ModuleTitleInput}
                  containerStyle={{ width: '75%', height: '100%' }}
                  placeholder='Module Name'
                  value={idCardEditedData.name ?? ''}
                  onChange={(e) => setEditedDataField('name', e.target.value)}
                  name='moduleName'
                  validation={validationFunc}
                  errorMsg={'Module name must be longer than 1 char'}
                />
              </ModuleTitleAndInputWrapper>
              <ModuleTitleAndInputWrapper>
                <ModuleTitle>Project module's family name:</ModuleTitle>
                <DropDownWrapper>
                  <FamiliesDropdown
                    familyId={idCardEditedData.familyId}
                    setDataFunc={setMultipleEditFields}
                  />
                </DropDownWrapper>
              </ModuleTitleAndInputWrapper>
              <ModuleTitleAndInputWrapper>
                <ModuleTitle>Secondary system:</ModuleTitle>
                <DropDownWrapper>
                  <SecondarySystemDropdown
                    value={idCardEditedData.secondarySystem}
                    setDataFunc={setMultipleEditFields}
                  />
                </DropDownWrapper>
              </ModuleTitleAndInputWrapper>
              <ModuleTitleAndInputWrapper>
                <ModuleTitle>Design maturity:</ModuleTitle>
                <DropDownWrapper>
                  <Dropdown
                    options={DESIGN_MATURITY_OPTIONS}
                    value={idCardEditedData.designMaturity}
                    placeholder='Design Maturity'
                    onChange={(option) => {
                      setEditedDataField('designMaturity', option.value);
                    }}
                  />
                </DropDownWrapper>
              </ModuleTitleAndInputWrapper>
            </TitlesWrapper>
            <CommandsWrapper>
              <SaveChangesExitWrapper>
                <SaveChangesButton
                  title={'Save changes'}
                  disabled={false}
                  onClick={() => onSaveIdCard(idCardEditedData, idCardImages)}
                />
              </SaveChangesExitWrapper>
              <DiscardChangesButton
                type='transparentBackgroundButton'
                title='Discard changes'
                onClick={() => discardChangesHandler(idCardImages)}
              />
              <DeleteIdCardButton
                type='transparentBackgroundButton'
                title='Delete ID Card'
                onClick={deleteIdCardHandler}
              />
            </CommandsWrapper>
          </TitleAndCommandsWrapper>

          <TextualDetailsWrapper>
            <SectionTitle>Description:</SectionTitle>
            <DescriptionAndMainImageWrapper>
              <DescriptionEdit
                text={idCardEditedData.description ?? ''}
                onChange={(e) => setEditedDataField('description', e.target.value)}
              />
              <MainImageEdit
                image={idCardImages[0]}
                imageIndex={0}
              />
            </DescriptionAndMainImageWrapper>
            <SectionTitle>
              {idCardEditedData.characteristicsLabel && idCardEditedData.characteristicsLabel.length > 0
                ? idCardEditedData.characteristicsLabel
                : 'Characteristics:'}
            </SectionTitle>
            <CharacteristicsEdit
              characteristics={idCardEditedData.characteristics}
              onChange={(e) => {
                let updatedCharacteristic = idCardEditedData.characteristics[e.target.name];
                updatedCharacteristic.value = e.target.value;
                idCardEditedData.characteristics.splice(e.target.name, 1, updatedCharacteristic);
                setEditedDataField('characteristics', idCardEditedData.characteristics);
              }}
            />

            <SectionTitle>Physical:</SectionTitle>
            <PhysicalEdit
              totalWeightDry={idCardEditedData.totalWeightDry}
              length={idCardEditedData.length}
              width={idCardEditedData.width}
              height={idCardEditedData.height}
              onChange={(e) => setEditedDataField(e.target.name, e.target.value)}
            />
          </TextualDetailsWrapper>

          <SubMenusWrapper>
            <SubMenuItem
              title={'Views And Layouts'}
              component={<ViewsAndLayoutsEdit images={idCardImages.slice(1, 7)} />}
            />
            <SubMenuItem
              title={'Weight Breakdown'}
              component={
                <WeightBreakdownEdit
                  tableData={{
                    weightStructure: idCardEditedData.weightStructure,
                    weightMechanical: idCardEditedData.weightMechanical,
                    weightPiping: idCardEditedData.weightPiping,
                    weightElectrical: idCardEditedData.weightElectrical,
                    weightInstrument: idCardEditedData.weightInstrument,
                    totalWeightDry: idCardEditedData.totalWeightDry,
                    totalWeightFluids: idCardEditedData.totalWeightFluids,
                    totalWeightOperating: idCardEditedData.totalWeightOperating,
                  }}
                  setEditedDataField={setEditedDataField}
                />
              }
            />
            <SubMenuItem
              title={'Location on FPSO'}
              component={<LocationAndCraneCoverageEdit image={idCardImages[8]} />}
            />
            <SubMenuItem
              title={'Main Tie-Ins & Interfaces'}
              component={
                <MainTieInsEdit
                  title={idCardEditedData.tieInsComment ?? ''}
                  tableData={idCardEditedData.tieIns}
                  setEditedDataField={setEditedDataField}
                  tieInsOtherUtilities={idCardEditedData.tieInsOtherUtilities}
                  tieInsOtherNetworks={idCardEditedData.tieInsOtherNetworks}
                />
              }
            />
            <SubMenuItem
              title={'Key Equipment List'}
              component={
                <EquipmentListEdit
                  showUploadBtn={true}
                  idCard={idCardData}
                  title={idCardEditedData.equipmentListComment ?? ''}
                  tableData={idCardEditedData.equipmentList}
                  setEditedDataField={setEditedDataField}
                />
              }
            />
            <SubMenuItem
              title={'Documentation List'}
              component={
                <DocumentationListEdit
                  showUploadBtn={true}
                  idCard={idCardData}
                  tableData={idCardEditedData.documents}
                  setEditedDataField={setEditedDataField}
                />
              }
            />
            <SubMenuItem
              title={'Other Relevant Documents'}
              component={
                <OtherRelevantDocumentsEdit
                  tableData={idCardEditedData.otherDocuments}
                  setEditedDataField={setEditedDataField}
                />
              }
            />
            <SubMenuItem
              title={'Project Notes'}
              component={
                <ProjectNotesEdit
                  notes={idCardEditedData.resNotes}
                  setEditedDataField={setEditedDataField}
                />
              }
            />
          </SubMenusWrapper>
        </ImageContext.Provider>
      )}
    </IdCardWrapper>
  );
};

export default IdCardEdit;